// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ContactUsTopicsFormState, {
    ContactUsTopicsFormFieldValues,
} from "@store/Framework/Store/Greif/Components/ContactUsTopicsForm/ContactUsTopicsFormState";
import { Draft } from "immer";

const initialFormFieldValues: ContactUsTopicsFormState["formFieldValues"] = {
    attachments: { value: [] },
    emailAddress: { value: "" },
    firstName: { value: "" },
    lastName: { value: "" },
    location: { value: "" },
    message: { value: "" },
    phoneNumber: { value: "" },
    referenceProductId: { value: "" },
    shipToNumber: { value: "" },
};

const initialState: ContactUsTopicsFormState = {
    formFieldValues: initialFormFieldValues,
    formDraftFieldValues: initialFormFieldValues,
    isDirty: false,
};

const actions = {
    "Greif/Components/ContactUsTopicsForm/SetDraftFieldValues": (
        draft: Draft<ContactUsTopicsFormState>,
        action: { parameter: ContactUsTopicsFormFieldValues },
    ) => {
        draft.formDraftFieldValues = { ...draft.formDraftFieldValues, ...action.parameter };
    },
    "Greif/Components/ContactUsTopicsForm/SaveDraftFieldValues": (
        draft: Draft<ContactUsTopicsFormState>,
        action: { keys?: Array<keyof ContactUsTopicsFormFieldValues> },
    ) => {
        const draftFieldValues = action.keys?.length
            ? action.keys.reduce((result, key) => ({ ...result, [key]: draft.formDraftFieldValues[key] }), {})
            : draft.formDraftFieldValues;

        draft.formFieldValues = { ...draft.formFieldValues, ...draftFieldValues };
        draft.isDirty = true;
    },
    "Greif/Components/ContactUsTopicsForm/CancelDraftFieldValues": (
        draft: Draft<ContactUsTopicsFormState>,
        action: { keys?: Array<keyof ContactUsTopicsFormFieldValues> },
    ) => {
        const savedFieldValues = action.keys?.length
            ? action.keys.reduce((result, key) => ({ ...result, [key]: draft.formFieldValues[key] }), {})
            : draft.formFieldValues;

        draft.formDraftFieldValues = { ...draft.formDraftFieldValues, ...savedFieldValues };
    },
    "Greif/Components/ContactUsTopicsForm/ResetFieldValues": (draft: Draft<ContactUsTopicsFormState>) => {
        draft.formFieldValues = initialFormFieldValues;
        draft.formDraftFieldValues = initialFormFieldValues;
        draft.isDirty = false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifComponentsContactUsTopicsFormActions = Parameters<typeof reducer>[1];
export default reducer;
